import React from 'react'
import PropTypes from 'prop-types'
import Item from './Item'
import Empty from './Empty'
import ReactImageFallback from 'react-image-fallback'
import imagefallback from '@loyal_images/products/product_placeholder.png'
const Items = props => {
  var rows = []
  if (!props.loading) {
    if (
      !props.productsWishList ||
      Object.keys(props.productsWishList).length === 0
    ) {
      rows.push(<Empty />)
    } else {
      for (var key in props.productsWishList) {
        var item = props.productsWishList[key]
        rows.push(
          <div className='col-12'>
            <Item
              product={item}
              key={key}
              selectItem={props.selectItem}
              checked={
                props.selectedItems &&
                props.selectedItems.filter(s => s.skuId === item.skuId)
              }
            />
          </div>
        )
      }
    }
  } else {
    return (<div className='wishlist-item row px-1 border-color-ui-3 border-bottom py-2'>
      <div className='wishlist-img col-auto col-md-auto txt-center px-0 pl-md-1 pr-md-2'>
        <ReactImageFallback
          src={imagefallback}
          fallbackImage={imagefallback}
          initialImage={imagefallback}
          className='card-image-fallback'
        />
      </div>

      <div className='wishlist-product-info col col-md-7 mr-0 mr-md-auto'>
        <div className='wishlist-product-info row'>
          <div className='product-infos col-12 mx-0'>
            <h2 className='txt-font-body txt-body-sm color-ui-2'>
              <div className='col-12 mb-1 py-half radius bg-ui-4' />
              <div className='col-6 py-half radius bg-ui-4' />
            </h2>
          </div>
        </div>

        <div className='row card-price-item mt-1'>
          <div className='wishlist-price-points col-12 txt-title-3 txt-font-body txt-left color-brand-1'>
            <div className='col-6 pt-3 radius bg-ui-3' />
          </div>
        </div>
      </div>
      <div className='col-auto icon-area row mx-0 px-0'>
        <div className='col-12 col-md-auto row mx-0 px-0'>
          <div className='row mx-0 align-items-center h-auto'>
            <div className='col-auto px-1 py-1 radius bg-ui-3 mr-1' />
          </div>
        </div>
        <div className='col-12 col-md-auto row mx-0 px-0'>
          <div className='row mx-0 align-items-center h-auto'>
            <div className='col-auto px-1 py-1 radius bg-ui-4' />
          </div>
        </div>
      </div>
    </div>)
  }

  return <div className='row px-0 pb-5 pb-md-0 mb-0 mb-md-5'>{rows}</div>
  // ) : (
  //   <div className='row px-0'>{rows}</div>
  // )
}

Items.propTypes = {
  productsWishList: PropTypes.object,
  selectItem: PropTypes.func,
  selectedItems: PropTypes.array,
  loading: PropTypes.bool
}

export default Items



// WEBPACK FOOTER //
// ./src/Participant/Wishlist/WishlistPage/Items.js